import React, {useEffect, useState} from 'react'
import _ from "lodash";
import {DocumentArrowUpIcon} from "@heroicons/react/24/solid";
import {useParams} from "react-router-dom";
import EditPodOverview from "./edit-pod-overview";
import {DEFAULT_POD_TAB, POD_TABS_LIST, SAVE_POD_TIME_DELAY} from "../../constants/pod.constant";
import {getSinglePod, updateSinglePod} from "../../services/pod-data-service";
import ShowTabsList from "../../../common/ui/show-tabs-list";
import ShowLink from "../../../common/ui/show-link";
import CategoryList from "../category/category-list";
import ProductsUploadDashboard from '../product-upload/products-upload-dashboard';
import ProductList from "../product/product-list";
import ParentProductList from "../parent-product/parent-product-list";
import ProductColorList from "../product-colors/product-color-list";
import SyncProductsDashboard from "../sync-products/sync-products-dashboard";

const tabsList = POD_TABS_LIST;

const EditPodDetails = () => {
    const {podId} = useParams();
    const [initialStep, setInitialStep] = useState(true);
    const [podDetail, setPodDetail] = useState(null);
    const [selectedTab, setSelectedTab] = useState(DEFAULT_POD_TAB);
    let [changesCount, setChangesCount] = useState(0);

    /*const [isSuccess, setIsSuccess] = useState(false);
    const [isError, setIsError] = useState(false);
    const [inputText, setInputText] = useState('');
    const [textItemList, setTextItemList] = useState([]);*/

    useEffect(() => {
        if (podId && initialStep) {
            getSinglePod(podId)
                .then(response => {
                    const podDetail = _.cloneDeep(response.data());
                    podDetail.id = podDetail.id || podId;
                    setPodDetail(podDetail);

                    console.log('podDetail', podDetail);
                });
        }
    }, [podId, initialStep]);

    useEffect(() => {
        incrementChangesCount();
    }, [podDetail]);

    useEffect(() => {
        const timeoutId =
            setTimeout(async () => {

                if (changesCount > 0) {
                    resetChangesCount();
                    savePodChanges();
                }

            }, SAVE_POD_TIME_DELAY);

        return () => clearTimeout(timeoutId);
    }, [changesCount]);

    const savePodChanges = async () => {
        const existingPod = {...podDetail};

        if (!_.isEmpty(existingPod)) {
            await updateSinglePod(existingPod);
            console.log('-- POD Update Done --');
        }
    }

    const incrementChangesCount = () => {
        setChangesCount(++changesCount);
    }

    const resetChangesCount = () => {
        setChangesCount(0);
    }

    return (
        <>
            {podDetail &&

                <div className="justify-center bg-gray-200 rounded dashboard-container">

                    <div className="justify-start p-8">

                        <div className="items-center justify-start w-1/2 mb-4">
                            <div className="flex justify-start items-center mb-8">
                                <ShowLink label="Back"
                                          url="/pods"/>
                                <div className="text-xl ml-4">
                                    {podDetail?.displayLabel}
                                </div>
                            </div>
                        </div>

                        <div>
                            <ShowTabsList
                                setSelectedTab={setSelectedTab}
                                selectedTab={selectedTab}
                                tabsList={tabsList}/>
                        </div>

                        <div className="mt-4 px-8">

                            {selectedTab?.key === 'details' &&
                                <div>
                                    <EditPodOverview
                                        podDetail={podDetail}
                                        setPodDetail={setPodDetail}/>
                                </div>
                            }

                            {selectedTab?.key === 'product-colors' &&
                                <div>
                                    <ProductColorList podDetail={podDetail}
                                                      setPodDetail={setPodDetail}/>
                                </div>
                            }

                            {selectedTab?.key === 'products' &&
                                <div>
                                    <ProductList podDetail={podDetail}/>
                                </div>
                            }

                            {selectedTab?.key === 'parent-products' &&
                                <div>
                                    <ParentProductList podDetail={podDetail}/>
                                </div>
                            }

                            {selectedTab?.key === 'upload-products' &&
                                <div>
                                    <ProductsUploadDashboard
                                        podDetail={podDetail}
                                        setPodDetail={setPodDetail}/>
                                </div>
                            }

                            {selectedTab?.key === 'sync-products' &&
                                <div>
                                    <SyncProductsDashboard
                                        podDetail={podDetail}
                                        setPodDetail={setPodDetail}/>
                                </div>
                            }

                        </div>

                    </div>

                </div>

            }
        </>
    )
}

export default EditPodDetails
